"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ComparableHomesSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M18.37,17.41l-6.53-6.12a2,2,0,0,0-2.74,0L2.63,17.41A2,2,0,0,0,2,18.86V28a2,2,0,0,0,2,2H17a2,2,0,0,0,2-2V18.87A2,2,0,0,0,18.37,17.41Zm-3.75,3.37-5,4A1,1,0,0,1,9,25a1,1,0,0,1-.71-.29l-2-2a1,1,0,0,1,1.42-1.42l1.36,1.37,4.31-3.44a1,1,0,1,1,1.24,1.56Z"/><path d="M29.35,6.17l-4.18-3.9a1,1,0,0,0-1.34,0l-4.18,3.9A2.1,2.1,0,0,0,19,7.69V14a1,1,0,0,0,1,1h9a1,1,0,0,0,1-1V7.69A2.1,2.1,0,0,0,29.35,6.17ZM27.12,9.78l-2.5,2A1,1,0,0,1,24,12a1,1,0,0,1-.71-.29l-1-1a1,1,0,0,1,1.42-1.42l.36.37,1.81-1.44a1,1,0,1,1,1.24,1.56Z"/>';
var ComparableHomesSVG = function ComparableHomesSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.ComparableHomesSVG = ComparableHomesSVG;
ComparableHomesSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(ComparableHomesSVG);
exports.default = _default;